import { API_GET } from "../../config";

export const GetBusinessUser = (page) => {
  return API_GET(`/api/user/get-all?&count=${page}&account_type=2`);
};
